// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__32_vc","content":"styles_content__3D-1O","checkbox":"styles_checkbox__zAFr6","checkboxLabel":"styles_checkboxLabel__Qerts"};